import React from 'react';
import styled from 'styled-components';
import Container from 'components/_utility/Container';
import { minBp, maxBp } from 'lib/theme';

export const Wrap = styled(Container)`
  ${({ listView }) => `
    display: grid;
    padding: 32px;
    grid-gap: 32px;
    grid-template-columns: 1fr;

    @media ${minBp('tablet')} {
      grid-template-columns: 1fr 1fr;
    }

    @media ${minBp('tabletLarge')} {
      grid-template-columns: 1fr 1fr 1fr;
      grid-auto-rows: 464px;
    }

    @media (min-width: 1244px) {
      padding: 32px 0;
    }

    @media ${minBp('desktop')} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      display: flex;
      flex-wrap: wrap;
    }
    
    ${
      listView
        ? `
      display: flex;
      flex-direction: column;
    `
        : ``
    }
  `}
`;

export const ButtonWrap = styled.div`
  padding: 8px 32px 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    @media ${maxBp('mobileEnd')} {
      width: 100%;
    }
  }
`;
